import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

import { MOBILE_FEATURE_IMAGE_WIDTH, DESKTOP_FEATURE_IMAGE_WIDTH } from './experiment-carousel/experiment-carousel'

interface ExperimentModalStyles {
  containerOverlay: Styles
  drawer: Styles
  closeIcon: Styles
  closeButton: Styles
  ctaButton: Styles
}

interface ExperimentModalStylesProps {
  isMobile: boolean
}

export const useStyles = createUseStyles<ExperimentModalStyles, ExperimentModalStylesProps>((theme) => {
  return {
    '@keyframes fadein': {
      from: { opacity: 0, bottom: 0 },
      to: { opacity: 1, bottom: 30 },
    },
    '@keyframes fadeout': {
      from: { opacity: 1, bottom: 30 },
      to: { opacity: 0, bottom: 0 },
    },
    containerOverlay: {
      position: 'fixed',
      top: theme.calcUnit(0),
      bottom: theme.calcUnit(0),
      left: theme.calcUnit(0),
      right: theme.calcUnit(0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: 1,
      pointerEvents: 'all',
      transition: 'opacity 200ms ease-in',
      zIndex: theme.zIndex.highestLevel,
      backdropFilter: `brightness(0.2)`,
    },
    drawer: ({ isMobile }) => ({
      position: 'relative',
      width: isMobile ? theme.calcUnit(MOBILE_FEATURE_IMAGE_WIDTH) : theme.calcUnit(DESKTOP_FEATURE_IMAGE_WIDTH),
      objectFit: 'cover',
      '& .carousel-slider': {
        borderRadius: theme.calcUnit(theme.borderRadius.roundedLg),
      },
    }),
    closeButton: ({ isMobile }) => ({
      position: 'absolute',
      right: theme.calcUnit(12),
      top: theme.calcUnit(10),
      height: isMobile ? theme.calcUnit(30) : theme.calcUnit(32),
      width: isMobile ? theme.calcUnit(30) : theme.calcUnit(32),
      backgroundColor: theme.colors.inverseTextColor,
      borderRadius: theme.calcUnit(theme.borderRadius.roundedFull),
      cursor: 'pointer',
      zIndex: theme.zIndex.levelOne,
    }),
    closeIcon: {
      position: 'absolute',
      opacity: '0.8',
      top: theme.calcUnit(4),
      right: theme.calcUnit(4),
    },
    ctaButton: ({ isMobile }) => ({
      display: 'block',
      width: isMobile
        ? theme.calcUnit(MOBILE_FEATURE_IMAGE_WIDTH - 24)
        : theme.calcUnit(DESKTOP_FEATURE_IMAGE_WIDTH - 32),
      margin: 'auto',
      marginTop: isMobile ? theme.calcUnit(theme.spacing.s2) : theme.calcUnit(theme.spacing.s3),
      marginBottom: theme.calcUnit(theme.spacing.s3),
      padding: isMobile ? theme.calcUnit(theme.spacing.s3) : theme.calcUnit(theme.spacing.s5),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      borderWidth: theme.calcUnit(1),
      borderStyle: 'solid',
      borderColor: theme.colors.alternateButtonTextColor,
      backgroundColor: theme.colors.backgroundColor,
    }),
  }
})
